import * as Sentry from '@sentry/react';

import {prepare, render} from './init';

import initHeap from 'analytics/heap';
import Root from 'app/Root';
import ErrorDisplayBoundary from 'common/error-display-boundary/ErrorDisplayBoundary';

const IS_DEV = import.meta.env.DEV;

if (!IS_DEV) {
    Sentry.init({
        autoSessionTracking: true,
        dsn: import.meta.env.HAL_SENTRY_DSN,
        environment: import.meta.env.HAL_ENVIRONMENT,
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/#decluttering-sentry
        ignoreErrors: [
            // Random plugins/extensions
            'top.GLOBALS',
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            'originalCreateNotification',
            'canvas.contentDocument',
            'MyApp_RemoveAllHighlights',
            'http://tt.epicplay.com',
            `Can't find variable: ZiteReader`,
            'jigsaw is not defined',
            'ComboSearch is not defined',
            'http://loading.retry.widdit.com/',
            'atomicFindClose',
            // Facebook borked
            'fb_xd_fragment',
            // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
            // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
            'bmi_SafeAddOnload',
            'EBCallBackMessageReceived',
            // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
            'conduitPage',
        ],

        normalizeDepth: 5,

        release: import.meta.env.HAL_RELEASE,

        replaysOnErrorSampleRate: 1.0,

        tracesSampleRate: 0.05,

        replaysSessionSampleRate: 0.1,

        denyUrls: [
            // Facebook flakiness
            /graph\.facebook\.com/i,
            // Facebook blocked
            /connect\.facebook\.net\/en_US\/all\.js/i,
            // Woopra flakiness
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // Other plugins
            /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        ],
        integrations: [new Sentry.Replay()],
    });
}

/* istanbul ignore if */
if (import.meta.env.HAL_ENVIRONMENT === 'production') {
    // load Heap analytics
    initHeap('29577204');
}

prepare(IS_DEV)
    .then(() => {
        render(<Root />);
    })
    .catch(() => {
        render(<ErrorDisplayBoundary />);
    });
